import{Observable as e}from"../Observable.js";import{subscribeTo as r}from"../util/subscribeTo.js";import{scheduled as o}from"../scheduled/scheduled.js";function s(s,t){return t?o(s,t):s instanceof e?s:new e(r(s))}export{s as from};
